import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './modules/authentication/pages/login/login.component';
import { ValidateUserComponent } from './modules/authentication/pages/validate-user/validate-user.component';
import { AuthGuard } from './core/guards/auth.guard';
import { LoginGuard } from './core/guards/login.guard';
import { ResetPasswordComponent } from './modules/authentication/pages/reset-password/reset-password.component';
import { PermissionsEnum } from './shared/enums/tenants-permissions-enum';
import { PermissionGuardService } from './core/guards/permissions.guard';
import { desktopGuard } from './core/guards/desktop.guard';
import { mobileGuard } from './core/guards/mobile.guard';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/home',
  },
  {
    path: 'home',
    title: 'Home',
    canActivate: [AuthGuard, desktopGuard()],
    loadChildren: () =>
      import('./modules/home/home.module').then((m) => m.HomeModule),
  },
  {
    path: 'm',
    title: 'Home',
    canActivate: [AuthGuard, mobileGuard()],
    loadChildren: () =>
      import('./modules/home/home.mobile.module').then((m) => m.HomeMobileModule),
  },
  {
    path: 'admin',
    title: 'Admin',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/admin/admin.module').then((m) => m.AdminModule),
  },
  {
    path: 'unit-commands',
    title: 'Unit-Commands',
    data: { permission: PermissionsEnum.simAccess },
    canActivate: [AuthGuard, PermissionGuardService],
    loadChildren: () =>
      import('./modules/sim-global/sim-global.module').then(
        (m) => m.SimGlobalModule,
      ),
  },
  {
    path: 'shipment',
    title: 'Shipment',
    canActivate: [AuthGuard, PermissionGuardService],
    data: { permission: PermissionsEnum.shipmentAccess },
    loadChildren: () =>
      import('./modules/shipment/shipment.module').then(
        (m) => m.ShipmentModule,
      ),
  },
  {
    path: 'chat',
    title: 'Chat',
    canActivate: [AuthGuard, PermissionGuardService],
    data: { permission: PermissionsEnum.chatMonitorUnits },
    loadChildren: () =>
      import('./modules/chat/chat.module').then((m) => m.ChatModule),
  },
  {
    path: 'reports',
    title: 'Reports',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/reports/reports.module').then((m) => m.ReportsModule),
  },
  {
    path: 'phones-admin',
    title: 'Phones Admin',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/phones-admin/phones-admin.module').then(
        (m) => m.PhonesAdminModule,
      ),
  },

  {
    path: 'linker-driver-diagnostics',
    title: 'Linker Driver Diagnostics',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/linker-driver-diagnostics/linker-driver-diagnostics.module').then(
        (m) => m.LinkerDriverDiagnosticsModule,
      ),
  },
  {
    path: 'edi',
    title: 'EDI',
    canActivate: [AuthGuard, PermissionGuardService],
    data: { permission: PermissionsEnum.ediAccess },
    loadChildren: () =>
      import('./modules/edi/edi.module').then((m) => m.EdiModule),
  },
  {
    path: 'monitor',
    title: 'Monitor',
    canActivate: [AuthGuard, PermissionGuardService],
    data: { permission: PermissionsEnum.monitorView },
    loadChildren: () =>
      import('./modules/monitor/monitor.module').then((m) => m.MonitorModule),
  },
  {
    path: 'cameras',
    title: 'Monitoreo de Cámaras',
    // TODO: add `data: { permission: PermissionsEnum.camerasView }` once the backend grants it.
    canActivate: [AuthGuard, PermissionGuardService],
    loadChildren: () =>
      import('./modules/monitor-media/monitor-media.module').then((m) => m.MonitorMediaModule),
  },
  {
    path: 'tpms',
    title: 'Monitor TPMS',
    canActivate: [AuthGuard, PermissionGuardService],
    data: { permission: [PermissionsEnum.tpmsView, PermissionsEnum.dashboardFifthWheel] },
    loadChildren: () =>
      import('./modules/tpms/tpms.module').then((m) => m.TpmsModule),
  },
  { path: 'login', component: LoginComponent, canActivate: [LoginGuard] },
  { path: 'reset-password', component: ResetPasswordComponent, canActivate: [LoginGuard] },
  { path: 'validate-user/:token', component: ValidateUserComponent },
  { path: '**', redirectTo: '/home' }, // Wildcard route - must be last
  
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
